import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PageViewSlots,
  PageViewSlot,
} from '../pages/site';

const RouteViewSlots = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PageViewSlots />
      </Route>
      <Route path={`${path}/:_id`}>
        <PageViewSlot />
      </Route>
    </Switch>
  );
};

export default RouteViewSlots;
